import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { permanentRedirect } from '../helpers';

export type HashRedirectProps = {
  children: React.ReactElement;
};

/**
 * Handles the old, legacy, hash based routes be redirecting them to
 * their non hash-based routes.
 */
export default function HashRedirect({ children }: HashRedirectProps) {
  const navigate = useNavigate();
  const redirect = permanentRedirect(navigate);
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      return;
    }

    const newUrl = `${pathname}${hash.substring(1)}`;

    redirect(newUrl);
  }, [pathname, hash]);

  return children;
}
